export const numberWizardData = [
    {
      text: "Fill up your details and proceed next steps.",
    },
  ];
  

    export const stepperHorizontalData = [
      {
        step:"one",
        title:"Basic Info"
      },
      {
        step:"two",
        title:"Cart Info"
      },
      {
        step:"three",
        title:"Feedback"
      },
      {
        step:"four",
        title:"Finish"
      }
    ];

    export const paymentModeName = ["Visa", "MasterCard", "paypal"];
  
    export const currentCartData = [
      {
        imagePath: "product/13.png",
        productName: "T-shirt",
        productSum: "$98 * 2",
        price: "$400",
      },
      {
        imagePath: "email-template/4.png",
        productName: "Headphone",
        productSum: "$4*2",
        price: "$450",
      },
      {
        imagePath: "product/2.png",
        productName: "T-shirt ",
        productSum: "$10*2",
        price: "$234",
      },
      {
        imagePath: "dashboard-2/product/2.png",
        productName: "Chairs ",
        productSum: "$98*2",
        price: "$200",
      },
    ];
  
    export const currentCartFooter = [
      {
        footerTittle: "Sub Total :",
        price: "1284.00",
      },
      {
        footerTittle: "Discount :",
        price: "20.00",
      },
      {
        footerTittle: "Shipping Charge :",
        price: "100.78",
      },
      {
        footerTittle: "Tax :",
        price: "205.34",
      },
      {
        footerTittle: "Total (USD) :",
        price: "1569.7",
      },
    ];
  
    export const homeAndOfficeData = [
      {
        value: "shipping-choose1",
        label: "Home",
        name: "Filomena Green ",
        address: "2211 Fruitville Rd, Sarasota, Florida, US 34237",
        contact: "(941) 321-5643",
      },
      {
        value: "shipping-choose2",
        label: "Work",
        name: "Ms. Ila Runte DDS",
        address: " 1531 E 23rd St S, Independence, Mississippi, US 64055",
        contact: "(816) 252-4500",
      },
    ];
  
    export const shippingFormData = [
      {
        text: "Fill up your true details and next proceed.",
      },
    ];
    
    export const shippingNavData = [
      {
        activeTab: 1,
        iconClassName: "fa-user",
        tittle: "Billing",
      },
      {
        activeTab: 2,
        iconClassName: "fa-truck",
        tittle: "Shipping",
      },
      {
        activeTab: 3,
        iconClassName: "fa-money",
        tittle: "Payment",
      },
      {
        iconClassName: "fa-check-square",
        tittle: "Finish",
      },
    ];
  
    export const shippingMethodData = [
      {
        value: "standardDelivery",
        label: "Standard Delivery - Free",
        details: "Estimated 5-7 days shipping",
      },
      {
        value: "expressDelivery",
        label: "Express Delivery - $24",
        details: "Estimated 1-2 days shipping",
      },
    ];
  
    export const studentValidationData = [
      {
        text: "Please make sure fill all the filed before click on next button.",
      },
    ];
  
    export const verticalValidationData = [
      {
        text: "Fill up your true details and next proceed.",
      },
    ];

   export const countryList = ["Africa", "India", "Indonesia", "Netherlands", "U.K", "U.S"];
    
    export const verticalWizardTabData = [
      {
        iconClassName: "fa-user",
        tittle: "Your Info",
        tittleInforMation: "Add your details ",
      },
      {
        iconClassName: "fa-chain-broken",
        tittle: "Cart Info",
        tittleInforMation: "Add your a/c details",
      },
      {
        iconClassName: "fa-group",
        tittle: "Net Banking",
        tittleInforMation: "Choose your bank",
      },
    ];
  
    export const netBankingList = [
      {
        bankList: ["Industrial & Commercial Bank", "Agricultural Bank", "JPMorgan Chase & Co."],
      },
      {
        bankList: ["Construction Bank Corp.", "Bank of America", "HDFC Bank"],
      },
    ];
  
